// import Vue from 'vue'
// import consts from "@/consts"
// import range from "lodash/range";
import {getApiProps, updateObjectByDiff} from "@/lib/lib";
import consts from "@/consts";
// import {arraySplitIntoChunks} from "@/lib/lib";

const with_removed = String(process.env.VUE_APP_PACKAGE).includes('admin') ? {'force[with_removed]': 1} : {}
// const changedField = 'changed__time';

const collator = new Intl.Collator();
const sortByName = function (a, b) {
    let cmp = collator.compare(a?.name_ || '', b?.name_ || '')
    if (cmp) {
        return cmp;
    }
    return a.id - b.id;
}

let _shipmentsDevicesIndexCache = {arr: null, map: null}
function getShipmentsDevicesIndexMap(state) {
    if (_shipmentsDevicesIndexCache.arr !== state.shipmentsDevices) {
        _shipmentsDevicesIndexCache.map = new Map(state.shipmentsDevices.map((u, i) => [u.id, i]))
        _shipmentsDevicesIndexCache.arr = state.shipmentsDevices
    }
    return _shipmentsDevicesIndexCache.map
}

export default {
    state: {
        shipmentsDevicesFullLoad: false,
        shipmentsDevicesLiteLoad: false,
        shipmentsDevices: [],
    },
    actions: {
        fetchShipmentsDevices/*all*/({dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }

                dispatch('setLastCall', {name: 'fetchShipmentsDevices', args, time: Date.now() / 1000})
                dispatch('setLastCall', {name: 'fetchShipmentsDevicesChanged', args, time: Date.now() / 1000})

                const params = getApiProps('shipmentsDevices', args)
                this.$api.shipmentsDevices.getAll({...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && !response.data.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchShipmentsDevices', args, inprogress: false})
                        dispatch('setLastCall', {name: 'fetchShipmentsDevicesChanged', args, inprogress: false})
                    });
            })
        },
        fetchShipmentsDevicesAll({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (getters.isShipmentsDevicesLiteLoad) {
                    return resolve(getters.getShipmentsDevices.length)
                }
                dispatch('fetchShipmentsDevices', args)
                    .then((data) => {
                        commit('updateShipmentsDevices', data)
                        commit('setShipmentsDevicesLiteLoad', true)
                        commit('setShipmentsDevicesFullLoad', true)
                        resolve(data.length)
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        setTimeout(() => {
                            dispatch('fetchShipmentsDevicesAll', {})
                        }, 60 * 1000)
                    })
            })
        },
        fetchShipmentsDevicesChanged({dispatch, commit, getters}, args) {
            if (!getters.getApiToken || !getters.isShipmentsDevicesFullLoad) {
                return Promise.resolve(null)
            }

            dispatch('setLastCall', {name: 'fetchShipmentsDevicesChanged', args, time: Date.now() / 1000})

            args = {...consts.querySettings.filter, ...args}
            return dispatch('fetchShipmentsDevices', args)
                .then((data) => {
                    commit('updateShipmentsDevices', data)
                    return dispatch('fetchShipmentsDevices', {fields: 'id', expand: ''})
                })
                .then((data) => {
                    commit('filterShipmentsDevices', data)
                })
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchShipmentsDevicesChanged', args, inprogress: false})
                });
        },

        saveShipmentsDevice({dispatch}, device) {
            let fn = (device.id) ? 'updateShipmentsDevice' : 'createShipmentsDevice'
            return dispatch(fn, device);
        },
        createShipmentsDevice({commit}, device) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('shipmentsDevices')
                this.$api.shipmentsDevices.create(device, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data.error) {
                            commit('updateShipmentsDevice', response.data)
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        updateShipmentsDevice({commit}, device) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('shipmentsDevices')
                this.$api.shipmentsDevices.update(device.id, device, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data.error) {
                            commit('updateShipmentsDevice', response.data)
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        deleteShipmentsDevice({commit}, id) {//remove
            return new Promise((resolve, reject) => {
                const params = getApiProps('shipmentsDevices')
                this.$api.shipmentsDevices.delete(id, {...params, ...with_removed})//remove
                    .then((response) => {
                        if (response.status < 400 && (!response.data || !response.data.error)) {
                            if (!response.data) commit('deleteShipmentsDevice', id)
                            else commit('updateShipmentsDevice', response.data)
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
    },
    mutations: {
        setShipmentsDevicesFullLoad(state, FullLoad) {
            state.shipmentsDevicesFullLoad = state.shipmentsDevicesFullLoad || FullLoad
        },
        setShipmentsDevicesLiteLoad(state, LitaLoad) {
            state.shipmentsDevicesLiteLoad = state.shipmentsDevicesLiteLoad || LitaLoad
        },

        setShipmentsDevices(state, nShipmentsDevices) {
            nShipmentsDevices = nShipmentsDevices.map(u => {
                if (u?.name) u.name_ = u.name.toLocaleLowerCase()
                if (u?.hw_type) u.hw_type_ = u.hw_type.toLocaleLowerCase()
                if (u?.hw_id) u.hw_id_ = u.hw_id.toLocaleLowerCase()
                return u //Object.freeze(u)
            })
            nShipmentsDevices.sort(sortByName)
            state.shipmentsDevices = nShipmentsDevices
        },

        updateShipmentsDevices(state, nShipmentsDevices) {
            if (!state.shipmentsDevices.length) {
                nShipmentsDevices = nShipmentsDevices.map(u => {
                    if (u?.name) u.name_ = u.name.toLocaleLowerCase()
                    if (u?.hw_type) u.hw_type_ = u.hw_type.toLocaleLowerCase()
                    if (u?.hw_id) u.hw_id_ = u.hw_id.toLocaleLowerCase()

                    return u //Object.freeze(u)
                })
                nShipmentsDevices.sort(sortByName)
                state.shipmentsDevices = nShipmentsDevices
                // const chunks = arraySplitIntoChunks(nShipmentsDevices)//.reverse();
                // const pushOnRenderTask = () => {
                //     if (chunks.length === 0) return;
                //     let chunk = chunks.pop();
                //     state.shipmentsDevices.push(...chunk);
                //     setTimeout(() => {
                //     requestAnimationFrame(pushOnRenderTask);
                //     }, 300)
                //     //this.$nextTick().then(() => pushOnRenderTask())
                // }
                // pushOnRenderTask();
                return true
            }

            const indexById = getShipmentsDevicesIndexMap(state)
            nShipmentsDevices.forEach(function (nDevice) {
                if (nDevice?.name) nDevice.name_ = nDevice.name.toLocaleLowerCase()
                if (nDevice?.hw_type) nDevice.hw_type_ = nDevice.hw_type.toLocaleLowerCase()
                if (nDevice?.hw_id) nDevice.hw_id_ = nDevice.hw_id.toLocaleLowerCase()
                let i = indexById.has(nDevice.id) ? indexById.get(nDevice.id) : -1
                if (i < 0) {
                    indexById.set(nDevice.id, state.shipmentsDevices.length)
                    state.shipmentsDevices.push(nDevice) //(Object.freeze(nDevice))
                } else {
                //if (!state.shipmentsDevicesFullLoad || state.shipmentsDevices[i][changedField] != nDevice[changedField]) {
                    updateObjectByDiff(state.shipmentsDevices[i], nDevice)
                    // delete nDevice.id
                    // nDevice = {...state.shipmentsDevices[i], ...nDevice}
                    // state.shipmentsDevices[i] = nDevice //Object.freeze(nDevice)
                }
            })

        },
        filterShipmentsDevices(state, nShipmentsDevices) {
            // let Ids = state.shipmentsDevices.map(u=> u.id)
            let nIds = new Set(nShipmentsDevices.map(u => u.id))
            state.shipmentsDevices = state.shipmentsDevices.filter(u => nIds.has(u.id))
        },
        updateShipmentsDevice(state, nDevice) {
            if (nDevice?.name) nDevice.name_ = nDevice.name.toLocaleLowerCase()
            if (nDevice?.hw_type) nDevice.hw_type_ = nDevice.hw_type.toLocaleLowerCase()
            if (nDevice?.hw_id) nDevice.hw_id_ = nDevice.hw_id.toLocaleLowerCase()
            let i = state.shipmentsDevices.findIndex(u => (u.id == nDevice.id))
            if (i < 0) {
                state.shipmentsDevices.push(nDevice) //(Object.freeze(nDevice))
            } else {
            //if (!state.shipmentsDevicesFullLoad || state.shipmentsDevices[i][changedField] != nDevice[changedField]) {
                updateObjectByDiff(state.shipmentsDevices[i], nDevice)
                // delete nDevice.id
                // nDevice = {...state.shipmentsDevices[i], ...nDevice}
                // state.shipmentsDevices[i] = nDevice //Object.freeze(nDevice)
            }
        },
        deleteShipmentsDevice(state, id) {
            let i = state.shipmentsDevices.findIndex(u => (u.id == id))
            if (i != -1) {
                state.shipmentsDevices.splice(i, 1)
            }
        },

        clearShipmentsDevices(state) {
            state.shipmentsDevices = []
            state.shipmentsDevicesFullLoad = false
            state.shipmentsDevicesLiteLoad = false
        },
    },
    getters: {
        isShipmentsDevicesFullLoad(state) {
            return state.shipmentsDevicesFullLoad
        },
        isShipmentsDevicesLiteLoad(state) {
            return state.shipmentsDevicesLiteLoad
        },
        getShipmentsDevices(state) {
            return state.shipmentsDevices
        },
        getShipmentsUnits(state, getters) {
            return state.shipmentsDevices.map(d => getters.getUnitsByIds[d.id])
        },
        getShipmentsAvailableUnits(state, getters) {
            return state.shipmentsDevices
                .filter(d => !d?.uncompleted?.length)
                .map(d => getters.getUnitsByIds[d.id])
                .filter(v => v)
        },
    }
}
